import React from "react";

const Email = () => {
  return (
    <div className="email-container">
      <div className="email-content">
        <div className="header">
          <img src="/images/logo-queen-center.svg" alt="Logo Queen center" />
          <div className="right">
            <div className="buttons">
              <button>
                NAZORG
                <a href="/images/NAZORG.pdf" download>
                  <img
                    src="/images/icon-pdf.svg"
                    alt="Icon PDF"
                    className="pdf"
                  />
                </a>
              </button>
              <button>#QC13903</button>
            </div>
            <div className="address">
              <p>Graafseweg 274, 6532 ZV Nijmegen</p>
            </div>
          </div>
        </div>
        <hr />
        <div className="user-container">
          <div className="user">
            <p className="name">Samantha Jansen</p>
            <p className="email">s.jansen@gmail.com</p>
            <p className="phone">0615345878</p>
          </div>
          <hr />
          <div className="detail">
            <div className="treatment">
              <img src="/images/icon-treatment.svg" alt="Icon Treatment" />
              <p>Lipcorrectie (vullen)</p>
            </div>
            <div className="date">
              <img src="/images/icon-date.svg" alt="Icon Date" />
              <p>Vrijdag, 18 Februari</p>
            </div>
            <div className="time">
              <img src="/images/icon-time.svg" alt="Icon Time" />
              <p>10:00 uur</p>
            </div>
          </div>
        </div>
        <div className="note">
          <p className="title">Notitie</p>
          <p className="content">
            I would like to visit Queen center with my sister.
          </p>
        </div>
        <div className="body">
          <div className="quenstion">
            <p className="title">Maak je gebruik van fillers?</p>
            <div className="answer">
              <div className="yes">
                <p>Ja</p>
                <img src="/images/icon-selected.svg" alt="Icon selected" />
              </div>
              <div className="no">
                <p>Nee</p>
                <img src="/images/icon-empty.svg" alt="Icon empty" />
              </div>
            </div>
          </div>
          <div className="quenstion">
            <p className="title">Maak je gebruik van botox injecties?</p>
            <div className="answer">
              <div className="yes">
                <p>Ja</p>
                <img src="/images/icon-empty.svg" alt="Icon empty" />
              </div>
              <div className="no">
                <p>Nee</p>
                <img src="/images/icon-selected.svg" alt="Icon selected" />
              </div>
            </div>
          </div>
          <div className="quenstion">
            <p className="title">Ben je zwanger?</p>
            <div className="answer">
              <div className="yes">
                <p>Ja</p>
                <img src="/images/icon-empty.svg" alt="Icon empty" />
              </div>
              <div className="no">
                <p>Nee</p>
                <img src="/images/icon-selected.svg" alt="Icon selected" />
              </div>
            </div>
          </div>
          <div className="quenstion">
            <p className="title">Rook je (o.a. vape of waterpijp)?</p>
            <div className="answer">
              <div className="yes">
                <p>Ja</p>
                <img src="/images/icon-empty.svg" alt="Icon empty" />
              </div>
              <div className="no">
                <p>Nee</p>
                <img src="/images/icon-selected.svg" alt="Icon selected" />
              </div>
            </div>
          </div>
          <div className="quenstion">
            <p className="title">Doe je aan intensieve sport? </p>
            <div className="answer">
              <div className="yes">
                <p>Ja</p>
                <img src="/images/icon-selected.svg" alt="Icon selected" />
              </div>
              <div className="no">
                <p>Nee</p>
                <img src="/images/icon-empty.svg" alt="Icon empty" />
              </div>
            </div>
          </div>
        </div>
        <div className="signature">
          <p className="title">Handtekening</p>
          <img src="/images/signature-test.svg" alt="Signature" />
        </div>
      </div>
    </div>
  );
};

export default Email;
